const listingSubcategories = crm => ({ fieldName, dispatchWrapper, getState, eventName }) => {
	const { data } = getState();

	if (data[fieldName]) {
		crm.get({
			type: "listingSubCategory",
			filter: {
				ParentListingCategoryID: data[fieldName].value,
				IsActive: true
			},
			fields: "Title ListingCategoryID"
		}).then(res => {
			if (res.success && res.count) {
				const options = res.recs.map(category => ({ label: category.Title, value: category.ListingCategoryID }));
				dispatchWrapper("updateField", ["SubcategoryID", { options }]);
				if (eventName !== "onLoad" && data.SubcategoryID && options.findIndex(cat => cat.value === data.SubcategoryID.value) === -1) {
					dispatchWrapper("handleFormChange", ["SubcategoryID", "Int", []]);
				}
			} else if (eventName !== "onLoad") {
				dispatchWrapper("updateField", ["SubcategoryID", { options: [] }]);
				dispatchWrapper("handleFormChange", ["SubcategoryID", "Int", []]);
			}
		});
	}
};

export default listingSubcategories;
